import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

import { app_links } from "config";

const ContentTerminosPolitica = ({ typeContent = "" }) => {
    const myComponent = {
        height: "300px",
        overflow: "auto",
        scrollbarColor: "red",
        //background:'red',

        //border:'1px solid silver',
    };

    return (
        <div style={myComponent}>
            <div className="term-pol">
                {typeContent == "terminos" && (
                    <div className=" text-left">
                        <ul>
                            <ol>
                                <li>
                                    El acceso y uso de esta aplicación se rige
                                    por los “Términos y Condiciones” descritos a
                                    continuación, así como los establecidos en
                                    el sitio web Metro.pe, y por la legislación
                                    que se aplique en la República de Perú. En
                                    consecuencia, todo uso de esta página web y
                                    todas las transacciones que se realicen en
                                    él, como asimismo sus efectos jurídicos,
                                    quedarán regidos por estas reglas y
                                    sometidas a esta legislación.
                                    <br />
                                    <br />
                                    Los Términos y Condiciones contenidos en
                                    este instrumento se aplicarán y se entenderá
                                    que forman parte de todos los actos que se
                                    ejecuten o celebren mediante los sistemas de
                                    servicios comprendidos en esta plataforma
                                    entre los USUARIOS y CENCOSUD RETAIL PERU
                                    S.A., la cual se denominará en adelante
                                    también en forma indistinta como “la
                                    empresa”, o bien “la empresa oferente”, “el
                                    proveedor” o “METRO”, según convenga al
                                    sentido del texto.
                                    <br />
                                    <br />
                                    METRO se reserva el derecho de actualizar
                                    y/o modificar los Términos y Condiciones que
                                    detallamos a continuación en cualquier
                                    momento, sin previo aviso. Por esta razón
                                    recomendamos revisar los Términos y
                                    Condiciones antes de cada uso, sea a través
                                    de esta plataforma o consultando
                                    directamente en el siguiente <br />
                                    link:
                                    <a
                                        href={
                                            "https://cupones.metro.pe/terms_condition-public"
                                        }
                                    >
                                        https://cupones.metro.pe/terms_condition-public
                                    </a>
                                    <br />
                                    <br />
                                    A continuación, detallamos los Términos y
                                    Condiciones :
                                    <br />
                                    <br />
                                    <br />
                                </li>
                                <li>
                                    <strong>
                                        1. La aplicación
                                        <br />
                                        <br />{" "}
                                    </strong>
                                    La aplicación implementada hace referencia
                                    al software proporcionado por METRO para
                                    ofrecer beneficios mediante cupones de
                                    descuento los cuales pueden ser utilizados
                                    según su naturaleza en las cajas de nuestras
                                    tiendas o en nuestra tienda virtual{" "}
                                    <a href="https://www.metro.pe/">
                                        {" "}
                                        (https://metro.pe),
                                    </a>{" "}
                                    ,siendo ocasionalmente en cualquier
                                    actualización y en cualquier otro software o
                                    documentación que permite el uso de los
                                    mismos.
                                    <br />
                                    <br />
                                    “Términos de uso” hace referencia a los
                                    términos y condiciones relacionados con el
                                    uso de la plataforma y con lo detallado en
                                    el presente documento.
                                    <br />
                                    <br />
                                    La aplicación permite el acceso a los
                                    beneficios que METRO le otorga mediante
                                    cupones de descuento con vigencia indicada
                                    en el mismo. Para acceder a ellos, el
                                    usuario deberá ingresar con su usuario
                                    previamente registrado. Cuando los legales
                                    del cupón de descuento muestre “No
                                    transferible”, “Intransferible” o se indique
                                    “Para ti” deberá ser canjeado sólo por el
                                    usuario identificado en la plataforma y no
                                    podrá ser otorgado a un tercero, quién para
                                    canjearlo deberá mostrar su documento de
                                    identidad para su identificación.
                                    <br />
                                    <br />
                                </li>{" "}
                                <li>
                                    <strong>
                                        {" "}
                                        2. Registro del usuario o cliente.
                                        <br />
                                        <br />
                                    </strong>{" "}
                                    Será requisito necesario para la adquisición
                                    de estos beneficios ofrecidos en este sitio,
                                    la aceptación de estos Términos y
                                    Condiciones, así como el registro por parte
                                    del usuario. Se entenderán como conocidos y
                                    aceptados estos Términos y Condiciones por
                                    el sólo hecho del registro, en el que se
                                    incluirá una manifestación expresa del
                                    usuario sobre el conocimiento de las
                                    presentes condiciones de uso. El registro en
                                    esta plataforma es totalmente gratuito.
                                    <br />
                                    <br />
                                    Para registrarse, el usuario deberá brindar
                                    un correo electrónico vigente, recibir un
                                    código de confirmación (clave token) en su
                                    bandeja de correo y posteriormente
                                    ingresarlo en la casilla de registro para su
                                    validación. También podrá registrarse por
                                    medio de su cuenta de Facebook o Google. El
                                    usuario es responsable, en caso de compartir
                                    el dispositivo de acceso, de proteger sus
                                    claves y accesos frente al uso de terceros.
                                    <br />
                                    <br />
                                </li>{" "}
                                <li>
                                    <strong>
                                        3. Clave Secreta.
                                        <br />
                                        <br />{" "}
                                    </strong>
                                    El usuario asume totalmente la
                                    responsabilidad por el mantenimiento de la
                                    confidencialidad de su clave secreta
                                    registrada en este sitio web y/o la clave
                                    token enviada, así como el acceso mediante
                                    su usuario de Facebook o Google, los cuales
                                    le permiten acceder a estos beneficios y
                                    obtener información. Dichas claves y accesos
                                    son de uso personal y su entrega a terceros
                                    no involucra responsabilidad de METRO o de
                                    sus relacionadas en caso de mala utilización
                                    <br />
                                    <br />
                                </li>{" "}
                                <li>
                                    <strong>
                                        {" "}
                                        4. Derechos del usuario de este sitio.
                                        <br />
                                        <br />
                                    </strong>{" "}
                                    El usuario gozará de todos los derechos que
                                    le reconoce la legislación sobre protección
                                    al consumidor vigente en el territorio del
                                    Perú, además de los que se le otorgan en
                                    estos términos y condiciones. El usuario
                                    dispondrá en todo momento de los derechos de
                                    información y rectificación de los datos
                                    personales. La sola visita de este sitio en
                                    el cual se ofrecen estos beneficios a través
                                    de cupones no impone al consumidor
                                    obligación alguna, a menos que haya aceptado
                                    las condiciones ofrecidas por la empresa, en
                                    la forma indicada en estos términos y
                                    condiciones.
                                    <br />
                                    <br />{" "}
                                </li>{" "}
                                <li>
                                    <strong>
                                        5. Procedimiento para hacer uso de este
                                        sitio.
                                        <br />
                                        <br />
                                    </strong>{" "}
                                    Para los cupones ofrecidos por medio de este
                                    sitio, METRO informará a través de la
                                    plataforma de manera inequívoca y fácilmente
                                    accesible, los pasos que deben seguirse para
                                    realizar efectivo los beneficios. Según su
                                    naturaleza, esta solicitud pasará por un
                                    proceso de validación de datos del usuario,
                                    recolección de cupones seleccionados por el
                                    mismo usuario, uso de los cupones en tienda
                                    física o virtual, finalizando por un envío
                                    de correo electrónico confirmando su uso.
                                    <br />
                                    <br />{" "}
                                </li>{" "}
                                <li>
                                    <strong>
                                        6. Derecho de Propiedad Intelectual y
                                        Licencias
                                        <br />
                                        <br />
                                    </strong>{" "}
                                    Las marcas registradas, los derechos de
                                    copyright, los derechos de base de datos, y
                                    otras propiedades intelectuales de cualquier
                                    índole de la aplicación junto con el código
                                    de software subyacente, les pertenecen
                                    directamente a Metro.
                                    <br />
                                    <br />{" "}
                                </li>{" "}
                                <li>
                                    <strong>
                                        7. Condiciones de Uso
                                        <br />
                                        <br />
                                    </strong>{" "}
                                    Metro se reserva el derecho de modificar o
                                    retirar el servicio proporcionado conforme a
                                    estos términos de uso, en cualquier momento
                                    y por cualquier motivo.
                                    <br />
                                    <br />
                                </li>{" "}
                                <li>
                                    <strong>
                                        {" "}
                                        8. Disponibilidad
                                        <br />
                                        <br />{" "}
                                    </strong>{" "}
                                    Esta plataforma estará disponible para el
                                    uso adecuado del cliente, quién podrá
                                    acceder desde su smartphone u otros
                                    dispositivos electrónicos. Metro realizará
                                    todos los esfuerzos razonables para que la
                                    plataforma esté disponible permanentemente.
                                    <br />
                                    <br />
                                </li>{" "}
                                <li>
                                    <strong>
                                        {" "}
                                        9. Rescisión
                                        <br />
                                        <br />
                                    </strong>{" "}
                                    Metro podrá culminar el uso del servicio de
                                    la plataforma en cualquier momento y sin
                                    necesidad de comunicación alguna al Cliente.
                                    Toda la información almacenada de las
                                    interacciones de los usuarios con el
                                    dispositivo podrá ser utilizado para
                                    continuar brindándole beneficios hasta que
                                    el cliente decida desafiliarse.
                                    <br />
                                    <br />
                                </li>{" "}
                                <li>
                                    <strong>
                                        10. Limitación de la Responsabilidad
                                        <br />
                                        <br />{" "}
                                    </strong>{" "}
                                    En ninguna circunstancia Metro será
                                    responsable por la pérdida, sustracción o
                                    daño directo, indirecto de los cupones
                                    impresos mediante este dispositivo o
                                    cualquier otro medio.
                                    <br />
                                    <br />
                                </li>{" "}
                                <li>
                                    <strong>
                                        11. Protección De Datos Personales
                                        <br />
                                        <br />{" "}
                                    </strong>{" "}
                                    Toda la información personal que proporciona
                                    al hacer uso de la aplicación será utilizada
                                    por Metro conforme a la política de
                                    privacidad, que se puede consultar en:
                                    <a href="https://cupones.metro.pe/privacy-public">
                                        https://cupones.metro.pe/privacy-public
                                    </a>
                                    <br />
                                    <br />
                                </li>
                                <li>
                                    <strong>
                                        12. Disponibilidad de Productos <br />
                                        <br />
                                    </strong>
                                    Los beneficios entregados al usuario
                                    mediante esta plataforma pueden ser usados
                                    de acuerdo a la disponibilidad de stock y
                                    surtido que se tiene en la tienda en el
                                    momento del canje o de la tienda virtual
                                    según la naturaleza del cupón.
                                    <br />
                                    <br />
                                </li>
                                <li>
                                    <strong>
                                        13. Metodología de Canje <br />
                                        <br />
                                    </strong>{" "}
                                    <b>Cupones para tienda física.</b>
                                    <br />
                                    El usuario podrá seleccionar un máximo de 15
                                    cupones brindados en la plataforma y que
                                    corresponden a tienda física, generar el
                                    código de canje y mostrarlo a través de su
                                    smartphone al personal de cajas para que
                                    pueda ingresarlo y hacer efectivo los
                                    beneficios. El usuario deberá presentar su
                                    documento de identidad físico y presentar
                                    tarjeta bonus según la plataforma lo
                                    solicite luego de generarse el código. De
                                    presentarse un cupón delineado por un color
                                    plomo a su alrededor, sólo podrá usarse si
                                    el usuario afilia su bonus a la plataforma.
                                    <br />
                                    <br />
                                    No será válido presentar capturas de
                                    pantalla, descargas, fotos o similares, el
                                    código de canje solo será válido
                                    exhibiéndolo, al momento de su canje, desde
                                    la plataforma de la web de cupones (cuenta
                                    activa del cliente en su smartphone o
                                    dispositivo durante la exhibición).”
                                    <br />
                                    <br />
                                    En caso se emitan cupones bajo la modalidad
                                    de contador de canjes efectivos (cupones con
                                    limite horizontal) estos podrán canjearse
                                    sólo hasta agotar el fondo promocional
                                    (stock o cantidad de canjes comprometidos)
                                    establecido en cada legal o el cumplimiento
                                    de la fecha de vigencia, lo que ocurra
                                    primero.
                                    <br />
                                    <br />
                                    El canje de cupones generará su retiro
                                    automático de la cuenta de cupones del
                                    cliente. Una vez canjeado cada cupón, este
                                    no podrá ser devuelto a la cuenta de cupones
                                    del cliente por ningún motivo (lo que
                                    incluye el supuesto de devolución de
                                    compras).
                                    <br />
                                    <br />
                                    <b>Cupones para tienda virtual.</b>
                                    <br />
                                    El usuario sólo podrá elegir un cupón de los
                                    brindados en la plataforma en la sección de
                                    cupones virtuales para que pueda ser
                                    ingresado en la tienda virtual{" "}
                                    <a href="https://metro.pe" />{" "}
                                    (https://metro.pe) <a />
                                    por cada transacción que realice.
                                </li>
                            </ol>
                        </ul>
                    </div>
                )}
                {typeContent == "politica" && (
                    <div className="text-left">
                        <ol>
                            <li>
                                <strong>
                                    1. INTRODUCCIÓN. <br />
                                    <br />
                                </strong>
                                En CENCOSUD RETAIL PERÚ S.A. (en adelante
                                “Metro”), aseguramos la máxima reserva y
                                protección sobre aquellos datos personales de
                                los clientes/usuarios que sean ingresados en el
                                sitio en Internet de su propiedad:
                                <a href="https://cupones.metro.pe ">
                                    https://cupones.metro.pe{" "}
                                </a>
                                En este documento describimos la “Política de
                                Privacidad” (en adelante, también denominado
                                <b>“Política”</b>) que regula el tratamiento de
                                los datos personales que los clientes/usuarios
                                registran en el sitio web.
                                <br />
                                <br />
                            </li>
                            <li>
                                <strong>
                                    {" "}
                                    2. OBJETIVO. <br />
                                    <br />
                                </strong>
                                En Metro estamos especialmente interesados en
                                ofrecer a nuestros clientes/usuarios el más alto
                                nivel de seguridad y proteger la
                                confidencialidad de los datos que nos aportan.
                                Por ello, el tratamiento de sus datos para la
                                asignación de cupones de descuento se realiza en
                                un entorno de servidor seguro bajo protocolo SSL
                                (Secure Socket Layer), actualmente empleado por
                                las empresas más importantes del mundo para
                                realizar transacciones electrónicas seguras.
                                <br />
                                <br />
                                Nuestro sitio web ha sido creado y diseñado para
                                permitir la evaluación de las preferencias de
                                compra de nuestros clientes/usuarios en nuestras
                                Tiendas Virtuales y, en virtud a dicho análisis,
                                emitir cupones de descuento para sus compras.
                                <br />
                                <br />
                            </li>{" "}
                            <li>
                                <strong>
                                    {" "}
                                    3. DESTINATARIOS DE LOS DATOS PERSONALES.{" "}
                                    <br />
                                    <br />
                                </strong>
                                El destinatario de la información personal de
                                los usuarios/clientes que se recopile mediante
                                los formularios y/o documentos análogos es
                                Metro. Asimismo, pueden existir terceros
                                destinatarios para realizar funciones en nombre
                                y representación de Metro, los cuales tendrán
                                acceso a la información personal necesaria para
                                realizar sus funciones, pero no pueden usarla
                                para fines diferentes a los señalados en la
                                presente Política
                                <br />
                                <br />
                                En este sentido, siempre que terceros tengan
                                acceso a sus datos personales para el
                                tratamiento por encargo, la información de
                                dichos terceros, así como el tratamiento
                                específico que ejecutarán será informado
                                oportunamente en esta sección.
                                <br />
                                <br />
                                Es necesario precisar que los terceros tratarán
                                la información personal de acuerdo con la
                                presente Política y según lo permitido por la
                                legislación de Protección de Datos Personales.
                                <br />
                                <br />
                                La dirección de Metro, en condición de Titular
                                del banco de datos personales al que puede
                                dirigirse para revocar el consentimiento o
                                ejercer sus derechos como titular de los datos
                                personales, se encuentra identificado en el
                                numeral 13 de la presente Política.
                                <br />
                                <br />
                            </li>{" "}
                            <li>
                                <strong>
                                    {" "}
                                    4. LEGISLACIÓN.
                                    <br />
                                    <br />
                                </strong>{" "}
                                Esta política está regulada por la legislación
                                peruana y en particular por:
                                <br />
                                <br />
                                · Ley N° 29733 – Ley de Protección de Datos
                                Personales (en adelante, denominado “LPDP” ).
                                <br />
                                · Reglamento de la Ley N° 29733, aprobado por el
                                Decreto Supremo N° 003-2013-JUS (en adelante,
                                denominado “RLPDP” ).
                                <br />
                                · Directiva de Seguridad de la Información,
                                aprobada por la Resolución Directoral N°
                                019-2013-JUS/DGPDP (en adelante, denominado
                                “Directiva” ).
                                <br />
                                <br />
                                De acuerdo con la LPDP y el RLPDP, se entiende
                                por datos personales toda información numérica,
                                alfabética, gráfica, fotográfica, acústica,
                                sobre hábitos personales, o de cualquier otro
                                tipo concerniente a una persona natural que la
                                identifica o la hace identificable a través de
                                medios que pueden ser razonablemente utilizados.
                                <br />
                                <br />
                                Asimismo, se entiende por tratamiento de datos
                                personales a cualquier operación o procedimiento
                                técnico, automatizado o no, que permite la
                                recopilación, registro, organización,
                                almacenamiento, conservación, elaboración,
                                modificación, extracción, consulta, utilización,
                                bloqueo, supresión, comunicación por
                                transferencia o por difusión o cualquier otra
                                forma de procesamiento que facilite el acceso,
                                correlación o interconexión de los datos
                                personales.
                                <br />
                                <br />
                            </li>
                            <li>
                                <strong>
                                    {" "}
                                    5. CALIDAD DE LOS DATOS PERSONALES. <br />
                                    <br />
                                </strong>
                                Los datos personales solicitados a nuestros
                                clientes/usuarios, son datos básicos que
                                permiten personalizar la experiencia de visita a
                                nuestras Tiendas Virtuales y asignar los cupones
                                de descuento de manera individual. Estos datos
                                son adecuados, pertinentes y no excesivos en
                                relación con la finalidad para los que se
                                recogen
                                <br />
                                <br />
                                Los datos personales a los que en Metro
                                tendremos acceso, serán aquellos que los
                                clientes/usuarios faciliten voluntariamente
                                rellenando los formularios puestos a tal efecto.
                                <br />
                                <br />
                                En Metro les proporcionamos a nuestros
                                clientes/usuarios los recursos técnicos
                                adecuados para que tomen conocimiento de la
                                presente Política y de cualquier otra
                                información que pueda ser relevante.
                                <br />
                                <br />
                                Los datos personales facilitados por nuestros
                                clientes/usuarios tienen que ser exactos y
                                correctos de forma que respondan con veracidad a
                                su situación actual. En caso contrario estos
                                datos serán cancelados.
                                <br />
                                <br />
                                Los datos personales serán cancelados cuando
                                hayan dejado de ser necesarios para las
                                finalidades para las cuales han sido
                                recopilados. Sin embargo, se conservarán durante
                                el tiempo en que en Metro nos puedan exigir
                                algún tipo de responsabilidad derivada de esta
                                relación con nuestros clientes/usuarios.
                                <br />
                                <br />
                            </li>
                            <li>
                                <strong>
                                    {" "}
                                    6. TIEMPO DE CONSERVACIÓN DE SUS DATOS
                                    PERSONALES.
                                    <br />
                                    <br />
                                </strong>
                                Los datos personales del cliente/usuario serán
                                conservados en los términos establecidos en la
                                LPDP y el RLPDP, en el tiempo que sea necesario
                                para cumplir las finalidades identificadas en el
                                punto número 8 de la presente Política.
                                <br />
                                <br />
                                Metro, en condición de Titular del banco de
                                datos, se abstendrá de conservar los datos
                                personales del Consumidor/titular en los
                                siguientes eventos:
                                <br />
                                <br />
                                · Cuando tenga conocimiento de su carácter
                                inexacto o incompleto, sin perjuicio de los
                                derechos del cliente/usuario al respecto
                                <br />
                                · Cuando los datos personales objeto de
                                tratamiento hayan dejado de ser necesarios o
                                pertinentes para el cumplimiento de las
                                finalidades previstas en la presente Política,
                                salvo medie procedimiento de anonimización o
                                disociación. La supresión no procede cuando los
                                datos personales deban ser conservados en virtud
                                de un mandato legal o en virtud de las
                                relaciones contractuales entre Metro, en
                                condición de responsable del tratamiento y el
                                Titular de los datos personales, que justifiquen
                                el tratamiento de estos, con fundamento en el
                                Artículo 69 del RLPDP.
                                <br />
                                <br />
                            </li>
                            <li>
                                <strong>
                                    {" "}
                                    7. INFORMACIÓN QUE RECOLECTAMOS.
                                    <br />
                                    <br />
                                </strong>{" "}
                                Metro, como responsable del tratamiento, a
                                través de los formularios subidos en nuestra
                                página web y en documentos análogos, así como a
                                través de proveedores de servicios, redes
                                sociales, registros públicos y fuentes
                                accesibles al público, puede recopilar los
                                siguientes datos:
                                <br />
                                <br />
                                · Nombres y apellidos ·
                                <br />
                                · Correo electrónico ·
                                <br />
                                · Tipo de Documento .
                                <br />· Número de documento de identidad.
                                <br />
                                · Fecha de Nacimiento.
                                <br />
                                <br />
                            </li>
                            <li>
                                <strong>
                                    {" "}
                                    8. FINALIDAD DE LOS TRATAMIENTOS DE LA
                                    INFORMACIÓN PERSONAL. <br />
                                    <br />
                                </strong>
                                Las finalidades de tratamiento de los datos
                                personales que nuestros clientes/usuario
                                introducen en los diferentes formularios del
                                sitio web se orientan a evaluar sus preferencias
                                de compra y asignar cupones de descuento de
                                manera personalidad a fin que nuestros
                                clientes/usuario puedan acceder a beneficios y
                                descuentos en la ejecución de las transacciones
                                de compra de nuestros productos. Adicionalmente,
                                se tratarán los datos para la contestación de
                                sus consultas, peticiones y la atención de
                                cualquier otro tipo de información que nos
                                requieran a través de éstos
                                <br />
                                <br />
                                Los datos personales facilitados por nuestros
                                clientes/usuarios se almacenarán en los bancos
                                de datos que forman parte del sistema de
                                información de Metro y serán tratados para poder
                                llevar a cabo las finalidades expuestas
                                anteriormente.
                                <br />
                                <br />
                                Los bancos de datos que están registrados
                                actualmente ante la Autoridad de Protección de
                                Datos Personales son los siguientes:
                                <br />
                                <br />
                                · CLIENTES con código RNPDP-PJP N° 1680.
                                <br />
                                · COLABORADORES con código RNPDP-PJP N° 1681.
                                <br />
                                · CONTRO DE ACCESOS con código RNPDP-PJP N°
                                1682.
                                <br />
                                · PROVEEDORES con código RNPDP-PJP N° 1683.
                                <br />
                                · RECLUTAMIENTO DE COLABORADORES con código
                                RNPDP-PJP N° 1684.
                                <br />
                                · SEGURIDAD Y SALUD EN EL TRABAJO con código
                                RNPDP-PJP N° 1685.
                                <br />
                                · VIDEOVIGILANCIA con código RNPDP-PJP N° 1686.
                                <br />
                                Cabe destacar que este apartado se actualizará
                                conforme se hagan modificaciones en los bancos
                                de datos.
                                <br />
                                <br />
                                La dirección del titular del banco de datos es
                                la siguiente: Calle Augusto Angulo N° 130.
                                Urbanización San Antonio, distrito de
                                Miraflores, provincia y departamento de Lima.
                                <br />
                                <br />
                                La información que se recaba a través de los
                                formularios y/o documentos análogos alojados en
                                el sitio web de Metro se almacenarán en el banco
                                de datos denominado CLIENTES, inscrito ante la
                                Autoridad de Protección de Datos Personales con
                                el código RNPDP-PJP N° 1680.
                                <br />
                                <br />
                                En ese sentido, los bancos de datos que
                                contienen datos personales han sido inscritos en
                                el Registro de Protección de Datos de la
                                Autoridad de Protección de Datos Personales. Los
                                datos personales que faciliten nuestros
                                clientes/usuarios sólo podrán ser conocidos y
                                manejados por el personal de Metro que necesite
                                conocer dicha información para poder enviar
                                información o contestar las solicitudes de
                                nuestros clientes/usuarios. Estos datos
                                personales serán tratados de forma leal y lícita
                                y no serán utilizados para otras finalidades
                                incompatibles con las especificadas
                                <br />
                                <br />{" "}
                            </li>
                            <li>
                                <strong>
                                    9. COMUNICACIÓN POR TRANSFERENCIA DE DATOS
                                    <br />
                                    <br />
                                </strong>
                                En Metro respetamos la privacidad de nuestros
                                clientes/usuarios, no transferimos su
                                información a terceros si usted no desea
                                expresamente que lo hagamos.
                                <br />
                                <br />
                                Asimismo, es conveniente que nuestros
                                clientes/usuarios sepan que sus datos personales
                                podrán ser comunicados por transferencia a las
                                entidades administrativas, autoridades
                                judiciales y/o policiales, siempre y cuando esté
                                establecido por Ley.
                                <br />
                                <br />
                                Sin perjuicio de lo expresado, comunicamos a
                                nuestros clientes/usuarios que a fin de
                                gestionar de modo más eficiente las
                                transacciones y operaciones comerciales en
                                nuestra plataforma digital, y cumplir con sus
                                expectativas de compra, Metro podrá valerse de
                                proveedores de servicios (los cuales fueron
                                detallados en el punto 3 de la presente
                                Política) a fin de llevar adelante ciertas
                                actividades propias de la actividad comercial.
                                En consecuencia, respecto a los datos personales
                                de nuestros clientes/usuarios estos proveedores
                                tendrán la condición de encargados de
                                tratamiento de acuerdo a las disposiciones de la
                                LPDP y el RLPDP
                                <br />
                                <br />
                            </li>
                            <li>
                                <strong>
                                    {" "}
                                    10. FLUJO TRANSFRONTERIZO DE DATOS
                                    PERSONALES <br />
                                    <br />
                                </strong>
                                La información personal que se recopila mediante
                                los formularios, cupones de descuentos y/o
                                documentos análogos alojados en el sitio web de
                                Metro se almacena en nuestros servidores, los
                                cuales están alojados en Estados Unidos de
                                América.
                                <br />
                                <br />
                                En ese sentido, con la finalidad de ejecutar las
                                prestaciones que corresponden y que están
                                relacionadas con el servicio, y previa
                                declaración de la autoridad competente,
                                transfiere a los siguientes Terceros los datos
                                personales cuyo acceso ha sido brindado por
                                usted en condición de titular de la Información:
                                <br />
                                <br />
                                <b> Datos recopilados mediante formularios:</b>
                                <br /> · VTEX (Software as a Service) y Amazon -
                                EEUU (Ubicación Física: EEUU. Este - Norte de
                                Virginia us-east-1).
                                <br />
                                <b>Cupones de descuento:</b>
                                <br />
                                · IBM EEUU (Ubicación física: WDC01 4030
                                Lafayette Center Circle, Chantilly, VA 20151 /
                                WDC04 44060 Digital Loudoun Plaza (Bldg K)
                                Ashburn, VA 20147.
                                <br /> La inscripción de la comunicación del
                                flujo transfronterizo se hace a través del
                                formulario N° 66974. Es importante resaltar que
                                la única finalidad de dicha transferencia fuera
                                de territorio peruano es el almacenamiento,
                                conservación y mantenimiento de los datos
                                personales, y en ningún caso su circulación o
                                uso fuera de territorio peruano.
                                <br />
                                <br />
                            </li>{" "}
                            <li>
                                <strong>
                                    {" "}
                                    11. CONFIDENCIALIDAD DE LOS DATOS
                                    PERSONALES.
                                    <br />
                                    <br />{" "}
                                </strong>
                                Los datos personales facilitados por los
                                clientes/usuarios serán tratados con total
                                confidencialidad. Metro se compromete a guardar
                                secreto profesional indefinidamente respecto de
                                los mismos y garantiza el deber de guardarlos
                                adoptando todas las medidas de seguridad
                                necesarias.
                                <br />
                                <br />
                            </li>{" "}
                            <li>
                                <strong>
                                    12. SEGURIDAD DE LOS DATOS PERSONALES.
                                    <br />
                                    <br />
                                </strong>
                                En cumplimiento de la normativa vigente, en
                                Metro hemos adoptado las medidas técnicas de
                                seguridad apropiadas a la categoría de los datos
                                personales necesarias para mantener el nivel de
                                seguridad requerido, con el objetivo de evitar
                                la alteración, pérdida o el tratamiento o
                                accesos no autorizados que puedan afectar a la
                                integridad, confidencialidad y disponibilidad de
                                la información.
                                <br />
                                <br />
                                En Metro tenemos implementadas todas las medidas
                                de índole legal, técnica y organizativa
                                necesarias para garantizar la seguridad de los
                                datos personales y evitar su alteración, pérdida
                                y tratamiento y/o acceso no autorizado, teniendo
                                en cuenta el estado de la tecnología, la
                                naturaleza de los datos almacenados y los
                                riesgos a que están expuestos, ya sea que
                                provengan de la acción humana, del medio físico
                                o natural, tal y como establece la legislación
                                peruana vigente de protección de datos
                                personales.
                                <br />
                                <br />
                                En Metro también tenemos implementadas medidas
                                de seguridad adicionales para reforzar la
                                confidencialidad e integridad de la información
                                y continuamente mantenemos la supervisión,
                                control y evaluación de los procesos para
                                asegurar la privacidad de los datos personales.
                                Sin embargo, la transmisión de información
                                mediante las redes de comunicación y de Internet
                                no es totalmente segura; por eso, y a pesar de
                                que en Metro realizamos los mejores esfuerzos
                                para proteger los datos personales, no podemos
                                garantizar la seguridad de los mismos durante el
                                tránsito hasta el sitio web.
                                <br />
                                <br />
                                En tal sentido, toda la información nuestros los
                                clientes/usuarios proporcionen, se enviará por
                                su cuenta y riesgo. Es por ello que en Metro
                                recomendamos la máxima diligencia a nuestros
                                clientes/usuarios cuando trasladen a terceros o
                                publiquen información personal para evitar poner
                                en riesgo sus datos personales, eludiendo,
                                Metro, de toda responsabilidad en caso de
                                sustracciones, modificaciones o pérdidas de
                                datos ilícitas.
                                <br />
                                <br />
                            </li>{" "}
                            <li>
                                <strong>
                                    {" "}
                                    13. EJERCICIO DE DERECHOS.
                                    <br />
                                    <br />
                                </strong>
                                Los clientes/usuarios que nos hayan facilitado
                                sus datos personales, pueden dirigirse a Metro,
                                con el fin de poder ejercer sus derechos de
                                información, acceso, rectificación, cancelación
                                y oposición en los términos recogidos en la
                                legislación peruana vigente.
                                <br />
                                <br />
                                Los clientes/usuarios podrán ejercer sus
                                derechos presentando una solicitud escrita en
                                nuestra oficina principal, ubicada en Calle
                                Augusto Angulo Nº 130 Urb. San Antonio
                                Miraflores - Lima, conforme al{" "}
                                <a href="#">
                                    “Formato Modelo para el Ejercicio de
                                    Derechos ARCO”{" "}
                                </a>
                                en el horario establecido para la atención al
                                público o mediante el envío del formato
                                debidamente llenado al correo electrónico:
                                <a href="#">
                                    {" "}
                                    servicioalclienteonline@cencosud.com.pe
                                </a>{" "}
                                .
                                <br />
                                <br />
                            </li>
                            <li>
                                <strong>
                                    14. MENORES DE EDAD.
                                    <br />
                                    <br />{" "}
                                </strong>
                                En Metro entendemos la importancia de proteger
                                la privacidad de los niños, especialmente en un
                                entorno online. Por este motivo, nuestro sitio
                                web no está diseñado ni dirigido a menores de 14
                                años. Metro no llevará a cabo voluntariamente el
                                tratamiento de datos personales relativos a
                                menores de edad. En el supuesto que tengamos
                                conocimiento que los datos personales recogidos
                                corresponden a un menor de edad sin
                                autorización, adoptaremos las medidas oportunas
                                para eliminar estos datos tan pronto como sea
                                posible.
                                <br />
                                <br />{" "}
                            </li>{" "}
                            <li>
                                <strong>
                                    {" "}
                                    15. CONSENTIMIENTO. <br />
                                    <br />
                                </strong>
                                Al aceptar esta Política de Privacidad, nuestros
                                clientes/usuarios están de acuerdo con todos los
                                aspectos expuestos en este documento y nos
                                autorizan a tratar sus datos de carácter
                                personal para las finalidades expuestas
                                anteriormente.
                                <br />
                                <br />
                                El usuario/cliente titular de la información,
                                autoriza expresamente a Metro, a realizar el
                                tratamiento de sus datos personales
                                identificados en la presente Política,
                                ejecutando actividades tales como recopilar,
                                registrar, organizar, almacenar, conservar,
                                elaborar, modificar, extraer, consultar,
                                utilizar, bloquear, suprimir, comunicar por
                                transferencia, difundir, o cualquier otra forma
                                de procesamiento que facilite el acceso,
                                correlación o interconexión de los datos
                                personales de forma parcial o total, en los
                                términos expresados en la presente Política.{" "}
                                <br />
                                <br />
                            </li>
                            <li>
                                <strong>
                                    {" "}
                                    16. LAS CONSECUENCIAS DE PROPORCIONAR SUS
                                    DATOS PERSONALES Y SU NEGATIVA A HACERLO.
                                    <br />
                                    <br />
                                </strong>{" "}
                                El suministro de los datos personales
                                identificados en la presente Política y la
                                obtención expresa e inequívoca del
                                consentimiento contenido en la misma, conducirá
                                al tratamiento de los datos personales
                                suministrados por el titular de datos
                                personales, según las finalidades determinadas.
                                <br />
                                <br />
                                Usted en condición de titular de los datos
                                personales puede negarse a proporcionar sus
                                datos personales a Metro. Por lo que este último
                                se abstendrá de realizar el tratamiento de sus
                                datos personales, en caso de negarse a aceptar
                                la presente Política que contiene el
                                consentimiento para tratamiento de datos
                                personales. En este sentido, como consecuencia
                                de dicha acción, usted no podrá acceder al
                                servicio proporcionado por Metro para la Web de
                                Cupones de Descuento toda vez que para el
                                desarrollo del servicio resulta imprescindible
                                contar con los datos personales del titular.
                                <br />
                                <br />{" "}
                            </li>
                            <li>
                                <strong>
                                    17. VIGENCIA Y MODIFICACIÓN DE LA PRESENTE
                                    POLÍTICA DE PRIVACIDAD <br />
                                    <br />
                                </strong>
                                La Política de Privacidad web de Metroha sido
                                actualizada el mes de marzo del 2022.
                                <br />
                                <br />
                                Metro se reserva el derecho a modificar su
                                Política de Privacidad web en el supuesto de que
                                exista un cambio en la legislación vigente,
                                doctrinal, jurisprudencial o por criterios
                                propios empresariales. Si se introdujera algún
                                cambio en esta Política, el nuevo texto se
                                publicará en este mismo web. Se recomienda a
                                nuestros clientes/usuarios que accedan
                                periódicamente a esta Política de privacidad que
                                encontraran en este mismo sitio web.
                                <br />
                                <br />
                            </li>
                            <li>
                                <strong>
                                    18. OTROS <br />
                                    <br />
                                </strong>
                                Para realizar cualquier tipo de consulta
                                respecto a esta política puede dirigirse a la
                                siguiente dirección de correo electrónico:
                                <a href="#">
                                    {" "}
                                    servicioalclienteonline@cencosud.com.pe{" "}
                                </a>
                                .
                            </li>
                        </ol>
                    </div>
                )}

                {typeContent == "data-protection" && (
                    <div className="text-left">
                        <ol>
                            <li>
                                <strong>
                                    1. INFORMACIÓN PARA NUESTROS CLIENTES
                                    <br />
                                    <br />
                                </strong>
                                Los datos personales que el Cliente ha
                                facilitado en los formularios incluidos en
                                nuestro sitio Web, son utilizados con la
                                finalidad de evaluar sus preferencias de compra
                                y asignar cupones de descuento de manera
                                personalizada a fin que nuestros Clientes puedan
                                acceder a beneficios y descuentos en la
                                ejecución las transacciones de compra de los
                                productos que ofrecemos en nuestras Tiendas
                                Virtuales y Físicas. Dichos datos personales
                                serán incorporados al banco de datos denominado
                                “Clientes” de titularidad de Cencosud Retail
                                Perú S.A. (en adelante Metro)
                                <br />
                                <br />
                                El Cliente puede ejercer sus derechos de acceso,
                                actualización, inclusión, rectificación,
                                supresión y oposición, respecto de sus datos
                                personales en los términos previstos en la Ley
                                N° 29733 – Ley de Protección de Datos
                                Personales, y su Reglamento aprobado por el
                                Decreto Supremo N° 003-2013-JUS, conforme a lo
                                indicado en el acápite siguiente “Información
                                para el Ejercicio de Derechos ARCO”.
                                <br />
                                <br />
                            </li>
                            <li>
                                <strong>
                                    {" "}
                                    2. INFORMACIÓN PARA EL EJERCICIO DE DERECHOS
                                    ARCO <br />
                                    <br />
                                </strong>
                                El titular de los datos personales, para ejercer
                                sus derechos de acceso, actualización,
                                inclusión, rectificación, supresión y oposición,
                                o cualquier otro que la ley establezca, deberá
                                presentar una solicitud escrita en nuestra
                                oficina principal ubicada en Calle Augusto
                                Angulo Nº 130 Urb. San Antonio Miraflores –
                                Lima, conforme al “Formato Modelo para el
                                Ejercicio de Derechos ARCO” en el horario
                                establecido para la atención al público o
                                mediante el envío del formato debidamente
                                llenado al correo electrónico:
                                servicioalclienteonline@cencosud.com.pe.
                                <br />
                                <br />
                            </li>{" "}
                            <li>
                                <strong>
                                    {" "}
                                    3. FORMATOS MODELO PARA EL EJERCICIO DE
                                    DERECHOS ARCO <br />
                                    <br />
                                </strong>
                                En el siguiente enlace puede descargar los
                                Formatos Modelo para el Ejercicio de Derechos
                                ARCO.
                                <br />
                                <br />
                            </li>{" "}
                        </ol>

                        <a
                            className={"btn no-hover btn"}
                            href={app_links.data_protection_format}
                            target="_blank"
                            rel=" noreferrer"
                            download
                        >
                            DESCARGAR FORMATOS MODELO
                        </a>
                    </div>
                )}
                {typeContent == "cookies" && (
                    <div className="text-left">
                        <ol>
                            <li>
                                <h1>Políticas de cookies</h1>
                                <strong>
                                    1. INTRODUCCIÓN.
                                    <br />
                                    <br />
                                </strong>
                                CENCOSUD RETAIL PERÚ S.A. (en adelante,
                                “CENCOSUD”) describe en este documento la
                                “Política de Cookies” que regula este sitio web
                                (http://www.metro.pe) con el objetivo de
                                garantizar la privacidad del usuario del sitio
                                web (en adelante “EL USUARIO”). El sitio web es
                                propiedad de CENCOSUD, con domicilio en Calle
                                Augusto Angulo N° 130, Urbanización San Antonio,
                                Distrito de Miraflores, Provincia y Departamento
                                de Lima, Perú. Estas cookies permiten a CENCOSUD
                                facilitar el uso y navegación, garantizar el
                                acceso a determinadas funcionalidades y
                                adicionalmente, nos ayudan a mejorar la calidad
                                del sitio web de acuerdo con los hábitos y
                                estilos de navegación de “EL USUARIO”. CENCOSUD
                                utiliza cookies estrictamente necesarias y
                                esenciales para que usted utilice el sitio web y
                                que el sitio web funcione correctamente.
                                Asimismo, CENCOSUD informa “EL USUARIO” que
                                otras cookies sirven para mejorar el rendimiento
                                y su experiencia en el sitio web. CENCOSUD
                                informa a “EL USUARIO” que se va a proceder a la
                                recopilación y almacenamiento de los datos
                                personales. Dichos datos estarán incorporados en
                                el Banco de Datos denominado CLIENTES inscrito
                                mediante Resolución Directoral N°
                                341-2015-JUS/DGPDP-DRN en el Registro Nacional
                                de Protección de Datos Personales con el código
                                RNPDP-PJP N° 1680 de titularidad de CENCOSUD.
                                Adicionalmente, informamos a “EL USUARIO” que en
                                nuestro sitio web utilizamos cookies propias
                                como de terceros. De acuerdo con ello y la
                                finalidad de ejecutar su funcionalidad, CENCOSUD
                                transfiere dentro y fuera de territorio peruano
                                los datos personales de “EL USUARIO” a terceras
                                empresas. La relación de empresas antes
                                mencionadas podrá ser consultada a través del
                                siguiente enlace:
                                https://www.metro.pe/legales/datos-de-proveedores.
                                La recopilación de los datos personales
                                identificados en la presente Política de Cookies
                                y la obtención expresa e inequívoca del
                                consentimiento de la misma, conducirá al
                                tratamiento de los datos personales
                                suministrados por “EL USUARIO”, según las
                                finalidades determinadas. “EL USUARIO” puede
                                negarse a proporcionar sus datos personales
                                antes señalados; por lo que CENCOSUD se
                                abstendrá de realizar el tratamiento de los
                                mismos.
                                <br />
                                <br />
                            </li>
                            <li>
                                <strong>
                                    {" "}
                                    2. ¿QUÉ SON LAS COOKIES?
                                    <br />
                                    <br />
                                </strong>
                                Las cookies son pequeños archivos de texto que
                                los sitios web almacenan en su ordenador,
                                celular inteligente (smartphone), tablet o
                                cualquier otro dispositivo de acceso a Internet.
                                <br />
                                <br />
                            </li>{" "}
                            <li>
                                <strong>
                                    {" "}
                                    3. ¿PARA QUE SIRVEN?
                                    <br />
                                    <br />
                                </strong>
                                Las cookies sirven para reconocer el dispositivo
                                de “EL USUARIO” cuando vuelven a visitar el
                                sitio web, facilitándole su uso recordando sus
                                preferencias y configuración de navegación (p.
                                ej. Idioma, país, etc.). Asimismo, sirven para
                                mejorar los servicios que ofrecemos y para poder
                                recopilar información estadística que nos
                                permite entender cómo “EL USUARIO” utiliza este
                                sitio y permite mejorar su estructura y
                                contenidos. Algunas cookies son estrictamente
                                necesarias para que el sitio web funcione
                                correctamente y otras sirven para mejorar el
                                rendimiento y su experiencia como usuario. Las
                                cookies se asocian únicamente a un usuario
                                anónimo y su dispositivo de acceso a Internet y
                                no proporcionan referencias que permitan deducir
                                datos personales de “EL USUARIO”. Las cookies no
                                pueden dañar su dispositivo y además son muy
                                útiles, puesto que nos ayudan a identificar y
                                resolver errores. Mostramos información sobre
                                nuestra Política de Cookies en la parte superior
                                o inferior cada vez que se accede a Sitio web.
                                Ante esta información, “EL USUARIO” puede
                                realizar las siguientes acciones: Aceptar. No se
                                volverá a visualizar este aviso durante la
                                presente sesión. Modificar su configuración.
                                podrá modificar la configuración de su
                                navegación, pero ello no evitará que se muestre
                                el aviso sobre cookies al acceder a nuevas
                                páginas del sitio web. En caso el “USUARIO“
                                decida no elegir entre la aceptación o
                                modificación de la configuración, la información
                                indicada se seguirá mostrando durante su
                                navegación a fin de facilitar su acceso y
                                decisión.
                                <br />
                                <br />
                            </li>{" "}
                            <li>
                                <strong>
                                    {" "}
                                    4. TIPOS DE COOKIES.
                                    <br />
                                    <br />
                                </strong>
                                Según cual sea la entidad que gestione el sitio
                                Web desde donde se envíen las cookies y traten
                                los datos que se obtengan, se pueden distinguir
                                las siguientes: Cookies propias: Son aquellas
                                que se envían al dispositivo de acceso a
                                Internet de “EL USUARIO” desde el sitio web
                                gestionada por el propio titular del sitio web y
                                desde el que se presta el servicio solicitado
                                por el “EL USUARIO”. Cookies de tercero: son
                                aquellas que se envían al dispositivo de acceso
                                a Internet de “EL USUARIO” desde el sitio web
                                pero que no es gestionado por el titular del
                                sitio web, sino por otra entidad que trata los
                                datos obtenidos mediante las cookies. Según el
                                plazo de tiempo que permanecen activadas en el
                                dispositivo de acceso a Internet de “EL
                                USUARIO”, se pueden distinguir las siguientes:
                                Cookies de sesión: Son un tipo de cookies
                                diseñadas para recoger y almacenar datos
                                mientras “EL USUARIO” accede al sitio web. Se
                                suelen utilizar para almacenar información que
                                sólo interesa conservar para la prestación del
                                servicio solicitado por “EL USUARIO” en una sola
                                ocasión (la sesión que está utilizando en ese
                                momento). Cookies persistentes: Son un tipo de
                                cookies en que los datos siguen almacenados en
                                el dispositivo de acceso a Internet de “EL
                                USUARIO” y pueden ser accedidas y tratadas
                                durante un periodo definido por el responsable
                                de la cookies, y que puede ir de unos minutos a
                                varios años. Según la finalidad para la que se
                                traten los datos obtenidos mediante las cookies,
                                se pueden distinguir las siguientes: Cookies
                                Funcionales: Son las que permiten la navegación
                                óptima y el acceso a áreas seguras de la página
                                web, por lo cual la página web no podrá
                                funcionar adecuadamente sin estas cookies. Estas
                                cookies no almacenan ninguna información de
                                identificación personal. Cookies Analítica y
                                Optimización: Son aquellas que permiten al
                                editor de las mismas, el seguimiento y análisis
                                del comportamiento de los usuarios de los sitios
                                web a los que están vinculados. La información
                                recogida mediante este tipo de cookies se
                                utiliza en la medición de la actividad de los
                                sitios web, aplicación o plataforma y para la
                                elaboración de perfiles de navegación, con el
                                fin de introducir mejoras en función del
                                análisis de los datos de uso que hacen los
                                usuarios del servicio. Cookies técnicas: Las
                                cookies técnicas son aquellas imprescindibles y
                                estrictamente necesarias para el correcto
                                funcionamiento del sitio Web y la utilización de
                                las diferentes opciones y servicios que ofrece.
                                Son de este tipo, entre otras, las que sirven
                                para el mantenimiento de la sesión, la gestión
                                del tiempo de respuesta, rendimiento o
                                validación de opciones, utilizar elementos de
                                seguridad o compartir contenido con redes
                                sociales. Cookies de personalización: Son
                                aquellas que permiten a “EL USUARIO” acceder al
                                servicio con algunas características de carácter
                                general predefinidas en función de una serie de
                                criterios en el dispositivo de “EL USUARIO”,
                                como por ejemplo serían el idioma, el tipo de
                                navegador que utiliza para acceder al servicio,
                                la configuración regional desde donde accede al
                                servicio, etc. Cookies de Geo-localización:
                                Estas cookies son utilizadas para averiguar en
                                qué país se encuentra cuando se solicita un
                                servicio. Esta cookie es totalmente anónima, y
                                sólo se utiliza para ayudar a orientar el
                                contenido a su ubicación. Cookies de análisis:
                                Son aquellas que permiten al responsable de las
                                mismas, el seguimiento y análisis del
                                comportamiento de “EL USUARIO” en el sitio web.
                                La información recogida mediante este tipo de
                                cookies se utiliza en la medición de la
                                actividad del sitio web y para la elaboración de
                                perfiles de navegación de “EL USUARIO”, con el
                                fin de introducir mejoras en función del
                                análisis de los datos relacionados al uso del
                                servicio. Cookies publicitarias: Son aquellas
                                que permiten la gestión, de la forma más eficaz
                                posible, de los espacios publicitarios que, en
                                su caso, el titular haya incluido en el sitio
                                web desde el que presta el servicio solicitado
                                sobre la base de criterios como el contenido
                                editado o la frecuencia en la que se muestran
                                los anuncios. Cookies de publicidad
                                comportamental: Son aquellas que permiten la
                                gestión, de la forma más eficaz posible de los
                                espacios publicitarios que, en su caso, CENCOSUD
                                haya incluido en el sitio web desde el que
                                presta el servicio solicitado. Estas cookies
                                almacenan información del comportamiento de “EL
                                USUARIO” obtenida por la observación continuada
                                de sus hábitos de navegación, lo que permite
                                desarrollar un perfil específico para mostrar
                                publicidad en función de éste. Cookies de
                                Registro: Son aquellas que se generan una vez
                                que “EL USUARIO” se ha registrado o
                                posteriormente ha abierto su sesión, y se
                                utilizan para identificarle en los servicios de
                                forma que, si cierra un servicio, el navegador o
                                el ordenador, y en otro momento u otro día
                                vuelve a entrar en dicho servicio, seguirá
                                identificado, facilitando así su navegación sin
                                tener que volver a identificarse. Esta
                                funcionalidad se puede suprimir si “EL USUARIO”
                                pulsa la funcionalidad “cerrar sesión”, de forma
                                que estas cookies se eliminan y la próxima vez
                                que entre en el servicio “EL USUARIO” tendrá que
                                iniciar sesión para estar identificado.
                                <br />
                                <br />
                            </li>{" "}
                            <li>
                                <strong>
                                    {" "}
                                    5. ENLACES A REDES SOCIALES.
                                    <br />
                                    <br />
                                </strong>
                                En el sitio web también se incluyen indicadores
                                que “EL USUARIO” puede utilizar, de forma
                                sencilla e intuitiva, para enlazar y compartir
                                ciertos contenidos del sitio web con redes
                                sociales. Esta funcionalidad conlleva el uso de
                                cookies que enlazan con los sitios web de estas
                                redes sociales, almacenando la información
                                únicamente en ellas.
                                <br />
                                <br />
                            </li>{" "}
                            <li>
                                <strong>
                                    {" "}
                                    6. ¿QUÉ TIPO DE COOKIES UTILIZA ESTE SITIO
                                    WEB?
                                    <br />
                                    <br />
                                </strong>
                                Las cookies siguientes no identifican
                                personalmente a “EL USUARIO”, sólo proporcionan
                                información estadística anónima sobre la
                                navegación en este sitio web; sin embargo, puede
                                deshabilitarlas directamente configurando su
                                navegador. A continuación, se listan las cookies
                                que son utilizadas en este sitio web: Cookies
                                Funcionales: Son las que permiten la navegación
                                óptima y el acceso a áreas seguras de la página
                                web, por lo cual la página web no podrá
                                funcionar adecuadamente sin estas cookies. Estas
                                cookies no almacenan ninguna información de
                                identificación personal. Cookies Analítica y
                                Optimización: Son aquellas que permiten al
                                editor de las mismas, el seguimiento y análisis
                                del comportamiento de los usuarios de los sitios
                                web a los que están vinculados. La información
                                recogida mediante este tipo de cookies se
                                utiliza en la medición de la actividad de los
                                sitios web, aplicación o plataforma y para la
                                elaboración de perfiles de navegación, con el
                                fin de introducir mejoras en función del
                                análisis de los datos de uso que hacen los
                                usuarios del servicio. “El USUARIO” podrá
                                conocer esta y otras cookies que CENCOSUD
                                utiliza cuando ingresa al sitio web.
                                <br />
                                <br />
                            </li>{" "}
                            <li>
                                <strong>
                                    {" "}
                                    7. GESTIÓN DE LAS COOKIES.
                                    <br />
                                    <br />
                                </strong>
                                CENCOSUD asume un compromiso sobre el uso de
                                cookies, en consecuencia, otorga a “EL USUARIO”
                                acceso a información para que pueda comprender
                                qué tipo de cookies se utiliza en este sitio web
                                y la razón de ello. Con esto, CENCOSUD pretende
                                proporcionar a “EL USUARIO” transparencia en
                                cuanto a los datos tratados acerca de la
                                navegación realizada desde su equipo en el sitio
                                web. Si “EL USUARIO” acepta dichas cookies,
                                permite la mejora del sitio web de CENCOSUD para
                                ofrecerle un acceso óptimo y darle un servicio
                                más eficaz y personalizado. Además, “EL USUARIO”
                                puede configurar su navegador para establecer
                                que solo los sitios web de confianza o las
                                páginas por las que está navegando en este
                                momento puedan gestionar cookies, lo que le
                                permite seleccionar sus preferencias. Si “EL
                                USUARIO” decide no autorizar el tratamiento,
                                solo usaríamos las cookies técnicas, puesto que
                                son imprescindibles para la navegación por
                                nuestro sitio web. En este caso, no
                                almacenaríamos ninguna cookie. En caso “EL
                                USUARIO” rechace o borre las cookies de
                                navegación del sitio web, CENCOSUD no mantendrá
                                sus preferencias; y algunas características de
                                las páginas no estarán operativas, así como no
                                podremos ofrecerle servicios personalizados y
                                cada vez que vaya a navegar por este sitio web
                                se tendrá que solicitar a “EL USUARIO” de nuevo
                                su autorización para el uso de cookies. Si, aun
                                así, “EL USUARIO” decide modificar la
                                configuración de su acceso al sitio web, debe
                                saber que es posible eliminar las cookies o
                                impedir que se registre esta información en su
                                equipo en cualquier momento mediante la
                                modificación de los parámetros de configuración
                                de su navegador. Para bloquear o deshabilitar
                                las cookies, “EL USUARIO” deberá activar la
                                configuración del navegador, de manera que se
                                rechace la instalación de todas las cookies o de
                                algunas de ellas. En la práctica la mayoría de
                                los navegadores permiten advertir la presencia
                                de cookies o rechazarlas automáticamente. Si son
                                rechazadas se podrá seguir usando este sitio
                                web, aunque el uso de algunos de sus servicios
                                podrá ser limitado y por tanto la experiencia de
                                “EL USUARIO” puede ser menos satisfactoria. Los
                                accesos a la configuración de cookies de los
                                <br />
                                <br />
                            </li>{" "}
                            <li>
                                <strong>
                                    {" "}
                                    8. CONSULTAS
                                    <br />
                                    <br />
                                </strong>
                                Para realizar cualquier tipo de consulta
                                respecto a esta política puede dirigirse a la
                                siguiente dirección de correo electrónico:
                                servicioalclienteonline@cencosud.com.pe.
                                <br />
                                <br />
                            </li>{" "}
                            <li>
                                <strong>
                                    {" "}
                                    9. VIGENCIA Y MODIFICACIÓN DE LA PRESENTE
                                    POLÍTICA DE PRIVACIDAD
                                    <br />
                                    <br />
                                </strong>
                                La Política de Cookies web de CENCOSUD ha sido
                                actualizada el mes de diciembre del 2020.
                                CENCOSUD puede modificar esta Política de
                                Cookies en función de exigencias legislativas,
                                reglamentarias, jurisprudenciales o con la
                                finalidad de adaptar dicha política a las
                                instrucciones dictadas por la Autoridad Nacional
                                de Protección de Datos Personales, así como por
                                criterios propios institucionales. Por ello, y
                                dado que dicha política puede ser actualizada
                                periódicamente, sugerimos a “EL USUARIO” que la
                                revise de forma regular y que la encontrarán en
                                la web https://www.metro.pe. Fecha de última
                                actualización: 14/12/2020.
                                <br />
                                <br />
                            </li>{" "}
                        </ol>
                    </div>
                )}
            </div>
        </div>
    );
};

ContentTerminosPolitica.propTypes = {
    typeContent: PropTypes.string,
};
export default ContentTerminosPolitica;
